<template>
  <q-input
      dense
      v-bind:model-value="proxy"
      :label="label"
      lazy-rules
      :readonly="!edit"
      :outlined="edit"
      :clearable="edit"
      :rules="props.required ? [requiredRule] : []"
      :mask="appStore.dateMask"
      :class="` ${edit ? '' : 'q-mb-md'}`"
  >
    <template v-slot:append>
      <q-icon name="event" class="cursor-pointer">
        <q-popup-proxy
            v-if="edit"
            @before-show="updateProxy"
            transition-show="scale"
            transition-hide="scale"
        >
          <q-date
              v-model="proxy"
              mask="DD/MM/YY"
              :rules="props.required ? [requiredRule] : []"
              :options="d => dateOptions(d)"
          >
            <div class="row items-center justify-end q-gutter-sm">
              <q-btn label="Cancel" color="primary" flat v-close-popup />
              <q-btn
                  label="OK"
                  color="primary"
                  flat
                  v-close-popup
                  @click="save(proxy)"
              />
            </div>
          </q-date>
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>

<script setup>
import { defineProps, defineEmits, computed, getCurrentInstance } from "vue";
import { useAppStore } from "@/store/app-store";
import { date } from "quasar";

const appStore = useAppStore();
const DATE_MASK = "YYYY-MM-DD";

const props = defineProps({
  label: {},
  editable: { type: Boolean, default: false },
  edit: { type: Boolean, default: false },
  modelValue: {},
  required: { type: Boolean, default: false }
});

const edit = computed(
    () =>
        getCurrentInstance().parent.parent.exposed.edit.value &&
        (props.editable || getCurrentInstance().parent.parent.exposed.isNew.value)
);

const emit = defineEmits(["update:modelValue"]);
const requiredRule = v => !!v || "Campo obrigatório";

const updateProxy = () => {
  const currentDate = new Date();
  proxy.value = date.formatDate(currentDate, "DD/MM/YY");
};
const save = v =>
    emit("update:modelValue", date.formatDate(date.extractDate(v, "DD/MM/YY"), "YYYY-MM-DD"));
const proxy = computed({
  get: () =>
      props.modelValue
          ? date.formatDate(date.extractDate(props.modelValue, "YYYY-MM-DD"), "DD/MM/YY")
          : null,
  set: save
});
const dateOptions = (d) => {
  let today = date.formatDate(Date.now(), DATE_MASK);
  let diffFromToday = date.getDateDiff(today, d, "days");
  let isPast = diffFromToday >= -1;
  return isPast
};


</script>
